import events from './element-events';
import { common, baseComponents } from '@tencent/ceiba-base-components';
import Vue from 'vue';
import qs from 'qs';

// 从url中兼容获取上报的trace_id,放到ext中
const currentQuery = qs.parse(window?.location.search.substring(1));
const reportExt = {};
if (Object.prototype.hasOwnProperty.call(currentQuery, 'trace_id')) {
  reportExt.trace_id = currentQuery.trace_id;
}
if (Object.prototype.hasOwnProperty.call(currentQuery, 'track_id')) {
  reportExt.trace_id = currentQuery.track_id;
}

export default {
  mixins: [events],
  computed: {
    pageConfig() {
      return this.pageInfo || {};
    },
  },
  created() {
    console.log('hook created mixin');
    this.initEvents(this.pageConfig.events);
  },
  async mounted() {
    // 初始化整个画布
    console.log('hook mounted mixin');
    await this.initUI();
    await this.initLogic();
  },
  watch: {
    'actInfo.page_id'(val) {
      try {
        console.log('watch page_id ', val);
        // 内部切换页面同步上报pv
        const ceibaExt = {
          ceiba_business_id: this.actInfo.ast,
          ceiba_activity_id: this.actInfo.activity_id,
          ceiba_component_id: 'v100001', // 默认pv
          ceiba_component_uid: val, // 默认pv,用活动的page_id
          ceiba_page_id: val,
        };
        // 1001 页面曝光
        window.ceibaReporter
          && window.ceibaReporter.enterPage({
            page_id: window.reportPageId,
            event_id: '1001',
            game_id: this.actInfo?.gid, // 取心悦gid为game_id
            data_id: this.actInfo.report_config['1001'],
            ceiba_ext: JSON.stringify(ceibaExt),
            ext: reportExt,
            activity_id: this.actInfo.uo_id, // 增加上报uo活动id
          });

        this.hookOnContainerChange();
        this.hookOnPageChange();
        if (this.actInfo.extendConfig.forceLogin) {
          this.$store.dispatch('checkLogin');
        }
      } catch (e) {
        console.log('watch page_id, err=', e);
      }
    },
  },
  methods: {

    async initUI() {
      try {
        console.log('initUI');
        // 注册监听
        this.adjustMinSize();
        this.registResize();
        // 优化
        this.loadingFirstPageImage();
        this.prefetchImage();
        // hook钩子
        this.hookOnContainerChange();
        this.hookOnPageChange();
      } catch (e) {
        console.error('initUI fail, err=', e);
      }
    },

    async initLogic() {
      try {
        console.log('initLogic');
        // 插件初始化
        await this.initPlugins();
        // 登录态初始化
        await this.initLogin();
      } catch (e) {
        console.error('initLogic fail, err=', e);
      }
    },
    async initPlugins() {
      // switchPlugin
      await this.entrySwitchCheck();
      await this.$ast.entryPoint();
      await this.$ast.initShare(Object.assign({}, this.shareConfig || {}, this.pageMeta || {}));
      await this.$report.init({ actInfo: this.actInfo || {}, pageInfo: this.pageInfo || {} });
    },

    async initLogin() {
      console.log('Vue.prototype.$axiosInstance.post=', Vue.prototype.$axiosInstance.post);
      this.$onLogined(async () => {
        const pageId = await this.handleDynamicPage();
        console.log('handleDynamicPage pageId=', pageId);
        if (pageId && pageId !== this.actInfo.page_id) {
          // 重置page_id，重新触发watch page_id 函数
          this.updatePageId(pageId);
          return;
        }
        this.refreshQua();
      });
      if (this.actInfo.extendConfig.forceLogin) {
        await this.$login.initLogin();
        this.$store.dispatch('checkLogin');
      }
    },
    /**
     * 处理动态页面流程操作
     * @returns page_id
     */
    async handleDynamicPage() {
      const { pageStatusFlowId, shareVisibleFlag, pageStatusRules, flowConfig } = this.actInfo.extendConfig;
      console.log('handleDynamicPage config:', pageStatusFlowId, shareVisibleFlag, pageStatusRules);
      if (!pageStatusFlowId || !flowConfig) return '';
      if (!pageStatusRules || pageStatusRules.length === 0) return '';
      try {
        // 根据流程获取当前人的对应页面ID
        const pageId = await this.getDynamicPageId(pageStatusFlowId, pageStatusRules);
        if (pageId) {
          this.assignUserInfo({ dynamicPageId: pageId });
          console.log('this.userInfo=', this.userInfo);
          return pageId;
        }
        // 处理邀请开关
        const cInviteCode = common.tool.getQueryparams('c_invite_code');
        if (!shareVisibleFlag || !cInviteCode) {
          return '';
        }
        const inviterPageId = await this.getInviterDynamicPageId(cInviteCode);
        return inviterPageId;
      } catch (e) {
        console.error('handleDynamicPage fail, e=', e);
      }
      return '';
    },
    async getDynamicPageId(pageStatusFlowId, pageStatusRules) {
      // 调流程获取返回
      const response = await this.flowRequest({
        flowId: pageStatusFlowId,
        params: {

        },
      });
      console.log('call pageStatusFlowId  response=  ', response);
      const { ret = 0 } = response;
      if (ret !== 0) {
        return '';
      }
      if (response.data.ret) {
        return '';
      }
      // 处理页面规则
      const responseData = response.data || {};
      const hitItem = pageStatusRules.find((rule) => {
        if (rule.key && rule.op && rule.value && rule.pageId) {
          const match = this.matchRule(rule, responseData);
          console.log('rule=', rule, responseData, match);
          return match;
        }
        return false;
      });
      if (hitItem) {
        return hitItem.pageId;
      }
      return '';
    },
    async getInviterDynamicPageId(inviteCode) {
      const params = {
        business: this.$actInfo.ast,
        activity: `${this.$actInfo.activity_id}`,
        invite_code: inviteCode,
      };
      const response = await baseComponents.Apis.User.getInviteInfo(params);
      console.log('getInviterDynamicPageId response ', response);
      const { ret, data = {}, msg } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '获取邀请人信息失败' });
        return '';
      }
      const { self = false, ext = '{}' } = data;
      if (self) return '';
      return JSON.parse(ext || '{}').dynamicPageId || '';
    },
    matchRule(rule, data) {
      switch (rule.op) {
        case '=':
          return `${data[rule.key]}` === `${rule.value}`;
        case '!=':
          return `${data[rule.key]}` !== `${rule.value}`;
        case '<':
          return data[rule.key] < parseInt(rule.value, 10);
        case '<=':
          return data[rule.key] <= parseInt(rule.value, 10);
        case '>=':
          return data[rule.key] >= parseInt(rule.value, 10);
        case '>':
          return data[rule.key] > parseInt(rule.value, 10);
        case 'in':
          return rule.value.split(',').includes(`${data[rule.key]}`);
        default:
          return false;
      }
    },
    async entrySwitchCheck() {
      // 检查是否有switchLink
      if (this.shareConfig.switchLink) {
        if (this.deviceMode === 'pc' && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          window.location.href = this.shareConfig.switchLink;
        }
        if (this.deviceMode === 'h5' && !(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent))) {
          window.location.href = this.shareConfig.switchLink;
        }
      }
    },
    adjustMinSize() {
      if (typeof document !== 'undefined') {
        document.body.style.minWidth = '0px';
        document.body.style.minHeight = '0px';
        document.body.style.overflowX = 'hidden';
        this.$on('hook:beforeDestroy', () => {
          document.body.style.minWidth = '';
          document.body.style.minHeight = '';
          document.body.style.overflowX = '';
        });
      }
    },
    hookOnContainerChange() {
      console.log('hookOnContainerChange');
      // 计算rem
      if (typeof document !== 'undefined') {
        document.documentElement.style.fontSize = this.rootFontSize;
      }
      this.hookOnPageChange();
    },
    reload() {
      console.log('reload');
      location.reload();
    },
    // resize时，更新画布缩放比例
    registResize() {
      const resizeFun = common.tool.funcThrottle(this.hookOnContainerChange, 500);
      window.addEventListener('resize', resizeFun);
      window.addEventListener('orientationchange', this.reload);
      this.$on('hook:beforeDestroy', () => {
        window.removeEventListener('resize', resizeFun);
        window.removeEventListener('orientationchange', this.reload);
      });
    },
    hookOnPageChange() {
      console.log('hook mixin page change');
    },
    // 处理非编辑界面定义事件
    async handleComponentEvents(args, componentId) {
      const [params] = args;
      if (!params) return;
      // 获取组件
      const { componentConfig } = this.pageConfig;
      const component = componentConfig.find(item => item.id === componentId);
      if (!component) return;
      // 约定: 每个事件必须携带一个uid
      const { eventUid, dataSource } = params;
      // 获取事件请求结果
      if (!eventUid) return;

      // 设置组件事件默认结果
      if (!component.configurationData.componentEventResult) {
        this.$set(component.configurationData, 'componentEventResult', {});
      }

      if (dataSource === 'openMenuLink') {
        // 菜单链接打开
        this.openComponentLink(component.configurationData, eventUid);
        return;
      }
    },
    /**
     * 执行已知的事件类型
     * @param {Object} event 需要执行的事件
     * @returns undefined
     */
    async handleDefinedEvents(event) {
      if (event.length === 0) return;
      const eventData = event[0].data || [];
      for (let i = 0, len = eventData.length; i < len; i++) {
        if (eventData[i] && this[`_event_${eventData[i].type}`]) {
          await this[`_event_${eventData[i].type}`](eventData[i], this.$refs);
        }
      }
    },

    initEvents(events) {
      const eventMap = {};
      events.forEach((e) => {
        if (!e.type || !e.to || !e.method) return;
        const eventName = e.type;
        if (!eventMap[eventName]) {
          eventMap[eventName] = [];
        }
        eventMap[eventName].push({
          from: e.from,
          to: e.to,
          method: e.method,
        });
      });
      // 遍历eventMap, 对每个事件注册到事件总线，调用对应的目标组件方法
      for (const [eventName, event] of Object.entries(eventMap)) {
        this.$eventBus.$on(eventName, (uid, ...args) => {
          event.forEach((e) => {
            console.log('this.$eventBus.$on|handler', eventName, e, uid, args);
            if (`${e.from}` !== `${uid}`) return;
            // eslint-disable-next-line no-underscore-dangle
            this._event_componentAction(e, args);
          });
        });
      }
    },
    /**
                 * 获取页面中所有图片链接
                 */
    getSrcsFromPage(componentConfig) {
      const srcs = [];
      // 组件中的图片信息
      for (let i = 0; i < componentConfig.length; i++) {
        const item = componentConfig[i];
        if (item.component === 'c-image') {
          const { src } = item.styles.image;
          src && srcs.push(src);
        } else if (item.component === 'c-carousel') {
          const { images } = item.styles.carousel;
          // const result = [];
          for (let i = 0; i < images.length; i++) {
            const { src } = images[i];
            src && srcs.push(src);
          }
          // item.styles.carousel.images = result;
        }
      }
      return srcs;
    },
    async loadingFirstPageImage() {
      if (!this.pageConfig) {
        return;
      }
      const { canvasConfig = {}, componentConfig } = this.pageConfig;
      const srcs = [];

      // 页面背景图片
      const { backgroundImage: { src: backgroundImageSrc } = {} } = canvasConfig;
      backgroundImageSrc && srcs.push(backgroundImageSrc);

      // 组件中的图片信息
      srcs.push(...this.getSrcsFromPage(componentConfig));

      // 加载完成判断
      await Promise.all([...new Set(srcs)].map(src => common.tool.loadImage(src)));
    },
    // 加载其他页面的图片信息 (无需再次水平导航logo)
    async prefetchImage() {
      if (!this.$actInfo.config) return;
      const srcs = [];
      // eslint-disable-next-line max-len, vue/max-len
      Object.entries(this.$actInfo.config.configs || {}).forEach(([pageId, { canvasConfig = {}, componentConfig }]) => {
        // 首页图片无需重复加载
        if (pageId !== this.pageId) {
          // 页面created后直接加载,因此(this.pageId)一定是首页
          // 页面背景图片
          const { backgroundImage: { src: backgroundImageSrc } = {} } = canvasConfig;
          backgroundImageSrc && srcs.push(backgroundImageSrc);
          // 组件中的图片信息
          srcs.push(...this.getSrcsFromPage(componentConfig));
        }
      });
      [...new Set(srcs)].forEach((href) => {
        const link = document.createElement('link');
        Object.assign(link, {
          rel: 'prefetch',
          as: 'image',
          href,
        });
        document.head.appendChild(link);
      });
    },
  },
};
